import Swiper from "swiper";
import { FreeMode } from "swiper/modules";

new Swiper(".options__slider", {
    modules: [FreeMode],
    slidesPerView: "auto",
    initialSlide: 1,
    centeredSlides: true,
    breakpoints: {
        768: {
            centeredSlides: false
        },
    },
});
